/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react'

export type SliderConfig = {
  brightness: undefined | string
  contrast: undefined | string
  invert: undefined | string
  saturate: undefined | string
  sepia: undefined | string
  grayscale: undefined | string
  blur: undefined | string
  opacity: undefined | string
}

export type Props = {
  imageUrl?: string
  setImageUrl?: (arg0: string) => void
  configRight?: SliderConfig
  configLeft?: SliderConfig
  handleChangeRight?: (name: string, value: number) => void
  handleChangeLeft?: (name: string, value: number) => void
  forceUpdate?: () => void
}

export type SliderProps = {
  other?: string
} & Props
export const SliderContext = React.createContext<SliderProps>({})

export const SliderProvider: React.FC = ({ children }) => {
  const initialConfig = {
    brightness: undefined,
    contrast: undefined,
    invert: undefined,
    saturate: undefined,
    sepia: undefined,
    grayscale: undefined,
    blur: undefined,
    opacity: undefined
  }
  const [configRight, setConfigRight] = React.useState<SliderConfig>(
    initialConfig
  )
  const [configLeft, setConfigLeft] = React.useState<SliderConfig>(
    initialConfig
  )
  const [imageUrl, setImageUrl] = React.useState('/snellen.png')

  const forceUpdate = () => {
    setConfigLeft(initialConfig)
    setConfigRight(initialConfig)
  }

  const changeValue = (name: string, value: number) => {
    let newValue: number | undefined = value
    if (newValue === 0) {
      newValue = undefined
    } else if (name === 'sepia' || name === 'grayscale') {
      newValue = value / 100
    } else if (name === 'opacity' || name === 'contrast') {
      const position = value / 10
      const values = [1, 0.9, 0.8, 0.7, 0.6, 0.5, 0.4, 0.3, 0.2, 0.1, 0]
      newValue = values[position]
    }
    return newValue
  }

  const handleChangeRight = (name: string, value: number) => {
    setConfigRight(config => ({
      ...config,
      [name]: changeValue(name, value)
    }))
  }

  const handleChangeLeft = (name: string, value: number) => {
    setConfigLeft(config => ({
      ...config,
      [name]: changeValue(name, value)
    }))
  }

  return (
    <SliderContext.Provider
      value={{
        imageUrl,
        setImageUrl,
        handleChangeRight,
        handleChangeLeft,
        configRight,
        configLeft,
        forceUpdate
      }}
    >
      {children}
    </SliderContext.Provider>
  )
}

export const useSlider = (): SliderProps => React.useContext(SliderContext)
